<div class="fixed bottom-6 right-6 z-50">
  <div
    *ngIf="open"
    class="absolute bottom-14 right-0 w-56 p-3 rounded-card2 bg-[var(--popover)] border border-[var(--border)] shadow-md grid grid-cols-4 gap-2"
  >
    <a
      *ngFor="let item of items"
      [href]="item.href"
      class="flex flex-col items-center justify-center p-2 rounded-lg text-[var(--foreground)] hover:bg-[var(--muted)] transition-colors"
      [title]="item.label"
    >
      <i class="pi text-xl mb-1" [ngClass]="item.icon"></i>
      <span class="text-xs">{{ item.label }}</span>
    </a>
  </div>
  <button
    type="button"
    class="w-12 h-12 rounded-full flex items-center justify-center shadow-md border border-[var(--border)] bg-[var(--card)] text-[var(--foreground)] hover:bg-[var(--muted)] transition-colors"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [attr.aria-label]="'_Ứng dụng nhanh_' | translate"
  >
    <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="block">
      <path d="M12 16H16V12H12M12 10H16V6H12M6 4H10V0H6M12 4H16V0H12M6 10H10V6H6M0 10H4V6H0M0 16H4V12H0M6 16H10V12H6M0 4H4V0H0V4Z" fill="currentColor"/>
    </svg>
  </button>
</div>
